import Link from 'next/link';
import { getRoute } from '@/src/packages/utils/routes';
import { tv } from 'tailwind-variants';
import { Box, Stack } from '@/src/packages/components';
import { paths } from '@/src/packages/routes';
import { pathParams } from '@/src/packages/routes/pathParams.enum';
import { useProductContext } from '@/src/packages/components/pages/Product/ProductContext';
import { ProductOptionHeading } from '@/src/packages/components/pages/Product/ProductControls/ProductOptions/ProductOptionsOptionHeading';

const useProductColorSelectorStyles = tv({
  base: 'border overflow-hidden w-8 h-8 rounded-full border-transparent hover:border-black p-1',
  variants: {
    isSelected: {
      true: 'border-black',
    },
  },
});

export type ColorNames = 'Red' | 'Green' | 'Blue' | 'Black' | 'Tan';

export const ColorHexCodes: { [key in ColorNames]: string } = {
  Black: '#000000',
  Blue: '#000000',
  Green: '#3a6639',
  Red: '#a33131',
  Tan: '#86482d',
};

export const getColorVariantHex = (name: string) => {
  return ColorHexCodes[name as ColorNames];
};

export const ProductVariantSelector = () => {
  const {
    selectedVariant,
    productVariant: {
      product: { variants },
    },
  } = useProductContext();

  const hex = getColorVariantHex(selectedVariant.productOptionValue.name);

  return (
    <>
      <ProductOptionHeading>
        Colour:
        {selectedVariant && (
          <span
            className="ml-1 font-normal"
            style={{
              color: hex,
            }}
          >
            {selectedVariant?.productOptionValue?.name}
          </span>
        )}
      </ProductOptionHeading>
      <Stack spaceX={2} direction="horizontal">
        {variants.map((variant, i) => {
          const isSelected =
            selectedVariant?.contentfulId === variant.contentfulId;

          const hex = getColorVariantHex(variant.productOptionValue.name);

          return (
            <Link
              key={i}
              href={getRoute({
                route: paths.PRODUCTS_SINGLE,
                params: { [pathParams.PRODUCT_SINGLE]: variant.slug },
              })}
            >
              <Box className={useProductColorSelectorStyles({ isSelected })}>
                <Box
                  className="h-full w-full rounded-full"
                  style={{
                    backgroundColor: hex,
                  }}
                />

                {selectedVariant?.productOptionValue?.name}
              </Box>
            </Link>
          );
        })}
      </Stack>
    </>
  );
};
